import { useEffect, useRef } from "react";
import { Tooltip } from "primereact/tooltip";

const isTooltipNode = (node: Node): boolean =>
    node instanceof Element && Boolean(node.closest('.p-tooltip'));

/**
 * Un solo Tooltip para todos los elementos con `nv-tip` + `data-pr-tooltip` de la vista (íconos de fila, tags,
 * celdas truncadas). Evita montar un Tooltip por botón en tablas largas. El Tooltip de PrimeReact enlaza los
 * targets una sola vez, así que se vuelve a enlazar cuando cambia el DOM (filas nuevas, pestañas, panel lateral).
 */
export default function NvTooltips() {
    const tooltipRef = useRef<Tooltip>(null);

    useEffect(() => {
        let frame = 0;
        const observer = new MutationObserver((records) => {
            const relevant = records.some(r =>
                !isTooltipNode(r.target) &&
                ![...r.addedNodes, ...r.removedNodes].every(isTooltipNode));
            if (!relevant) return;
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => tooltipRef.current?.updateTargetEvents(undefined as unknown as HTMLElement));
        });
        observer.observe(document.body, { childList: true, subtree: true });
        return () => {
            cancelAnimationFrame(frame);
            observer.disconnect();
        };
    }, []);

    return <Tooltip ref={tooltipRef} target=".nv-tip" event="both" position="top" showDelay={200} className="nv-tooltip" />;
}
